<template>
  <div>
    <section class="w-60 ml-5">
      <el-card class="box-card">
        <div class="clearfix" slot="header">
          <span class="title font_medium">设定学时</span>
        </div>
        <div class="text item">
          <span class="subtitle">请 输 入 学 时:</span>
          <el-row class="demo-autocomplete ml-10">
            <el-col :span="12">
              <el-input type="number" 
                style="width:200px"
                 placeholder="请输入学时"
                v-model="classHour"></el-input>

            </el-col>
          </el-row>
        </div>
      </el-card>
    </section>
    <section class="w-60 ml-5">
      <template v-if="scheduling">
        <el-card class="box-card">
          <div class="clearfix" slot="header" style="padding:5px 0;font-weight:600">
            <span class="title font_medium">确认排课信息</span>
          </div>
          <div class="text item">
            <span class="subtitle mr-6">类型 ：</span>
            <span>{{transferSchedulingType(scheduling.studyclass.type)}}  {{scheduling.studyclass.scname}}</span>
          </div>
          <div class="text item">
            <span class="subtitle mr-10">排课日期：</span>
            <span>{{scheduling.locations.date}}</span>
          </div>
          <div class="text text-flex">
            <span class="subtitle mr-10">上课地址：</span>
            <template v-for="item in scheduling.locations.addresses" >
              <p :key="item" style="padding-left:20px">{{item.address}} ({{item.lat}}-{{item.lng}}) 范围： {{transferGPSLevel(item.gpsoffsetlevel)}}</p>
            </template>
          </div>
          <div class="text">
            <span class="subtitle mr-10">配置课程：</span>
            <div class="conClass">
              <template v-for="(item,index) in scheduling.courses">
                <div class="anItem" :key="item.id">
                  <div class="mr-2">{{index+1}}.</div>
                  <div class="cont">
                    <span>课程名称：{{item.title}}</span>
                    <span>开始时间：{{item.starttime}}</span>
                    <span>结束时间：{{item.endtime}}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>


          <div class="text">
            <span class="subtitle mr-10">可见等级：</span>
            <div class="conClass ml-2 mt-1">
              <span>{{transferShowLevels(scheduling.showoptions.showlevel)}}</span>
            </div>
          </div>

        </el-card>
      </template>
    </section>

    <div class="button_box">
      <el-button @click="onClickPrevious">上一步</el-button>
      <el-button type="primary" @click="onClickCompleted">创建排课</el-button>
    </div>
  </div>
</template>


<script>

import {transferSchedulingType,transferGPSLevel,transferShowLevels} from "@/utils/optionsutils"


export default {
  name: "schedulinglocation",
  props:{
    timetype:{
      type: Number
    }
  },
  data() {
    return {
      classHour : 4,
      scheduling : null
    };
  },
  methods:{
    init(){
    },
    setSchedule(data){
      this.scheduling = data;

      console.log("setSchedule",data)
    },
    onClickCompleted(){
      let _this = this;

      if(!this.classHour){
        this.$confirm('学时数为0，是否确认创建排课？')
          .then(_ => {
            _this.$emit("onClickCompleted",this.classHour);
          })
      }
      else {
        this.$emit("onClickCompleted",this.classHour);
      }
    },

    transferSchedulingType(id){
      return transferSchedulingType(id);
    },

    transferGPSLevel(id){
      return transferGPSLevel(id);
    },

    transferShowLevels(id){
      return transferShowLevels(id);
    },

    onClickPrevious(){
      this.$emit("onClickPrevious")
    }
  },
  watch:{
    location(oldVal,newVal){

    }
  },
  
  computed:{


    
  },
  
  created() {

  },
  mounted(){
    let isAdmin = this.$store.getters['profileModule/isadmin'];
    console.log("mounted store isadmin",isAdmin)
    this.init();
  }
};
</script>


<style scoped lang="scss">
section {
  font-size: 13px;
  margin-bottom: 20px;
  .box-card {
    width: 100%;
    & ::v-deep .el-card__header {
      padding: 10px 0px;
      font-weight: 600;
    }
    & ::v-deep .el-card__body {
      padding-bottom: 10px;
    }
    .title {
      margin-left: 10px;
    }
    .item {
      display: flex;
      align-items: center;
    }
    .text {
      margin-bottom: 10px;
      .conClass {
        display: flex;
        flex-wrap: wrap;
      }
      .subtitle {
        margin-left: 10px;
        padding-right: 10px;
        font-size: 14px;
        font-weight: 500;
      }
      .anItem {
        display: flex;
        margin-top: 10px;
        margin-left: 30px;
        .cont {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}

.text-flex{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.button_box{
  padding-left: 20px ;
  padding-bottom: 20px;
  padding-top: 10px;
}
</style>